/**
 * The Chart.js pieces this app's charts are drawn from, registered once.
 *
 * Chart.js 4 ships tree-shakeable: nothing is available until it is registered,
 * and a controller/scale/element that no module registered fails at render with
 * a bare `"line" is not a registered controller`. Registering here rather than
 * in each chart means one list to keep and no chance of two charts disagreeing
 * about which pieces exist.
 *
 * Importing this module IS the registration — `register` is idempotent, so a
 * second importer costs nothing.
 */
import {
  CategoryScale,
  Chart,
  Filler,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
} from "chart.js";

Chart.register(
  LineController,
  // A CATEGORY x-scale, not a time scale: the report's charts plot the days
  // that were priced, evenly spaced, and both of them hand the axis strings
  // rather than Date objects (PerformanceLineChart says why at length).
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  // The soft fill under a lone line.
  Filler,
  Legend,
  Tooltip,
);

export { Chart };
